//imports
import {
    PM_USERS_DELETE_USER_OPEN_MODAL,
    PM_USERS_DELETE_USER_CLOSE_MODAL,
    PM_USERS_DELETE_USER_REQUEST,
    PM_USERS_DELETE_USER_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    deleteUserLoading: false,
    deleteUser: null,
    openModal: false,
    users: []
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case PM_USERS_DELETE_USER_REQUEST:
            return { ...state, deleteUserLoading: true }

        case PM_USERS_DELETE_USER_RESULT:
            return { ...state, deleteUserLoading: false, deleteUser: action.payload }

        case PM_USERS_DELETE_USER_OPEN_MODAL:
            return { ...state, openModal: true, users: action.payload }

        case PM_USERS_DELETE_USER_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CLEAR_REDUX:
            return ["", "DELETE_PMUSERS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
